// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../../intl/Intl_Utils.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../../../../context/user/User_Types_Utils.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Messages_FinancialCodes$DvmAdminFrontendFr from "../../../../../../intl/messages/easypack/Messages_FinancialCodes.bs.js";
import * as Order_Detail_Correct_Box$DvmAdminFrontendFr from "../Order_Detail_Correct_Box.bs.js";
import * as Order_Detail_Types_Order_Type$DvmAdminFrontendFr from "../../../Order_Detail_Types_Order_Type.bs.js";

function Order_Detail_Correct_Order_Content_NonFleet(Props) {
  var order = Props.order;
  var color = Props.color;
  var title = Props.title;
  var newestUndeployedCorrection = Props.newestUndeployedCorrection;
  var tooltipHeight = Props.tooltipHeight;
  var form = Props.form;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var checkEmptyString = function (string) {
    return Belt_Option.mapWithDefault(string, undefined, (function (x) {
                  if (x.length > 0) {
                    return x;
                  }
                  
                }));
  };
  var match$1 = Belt_Option.mapWithDefault(newestUndeployedCorrection, [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ], (function (x) {
          return [
                  Belt_Option.mapWithDefault(x.orderType, "", (function (x) {
                          if (Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(x) !== Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(Belt_Option.getWithDefault(order.header.orderOrderType, /* SO */0))) {
                            return " (" + Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString(x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.orderDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderOrderDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.shortCustomerName), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderCustomerName, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.customerFirstName), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderCustomerFirstName, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.newCarRegistrationDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderRegistrationDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.newCarRegistrationID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderRegistrationId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.parcStartDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.resultCalcPARCStartDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.parcEndDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.resultPARCEndDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.customerDiscount, "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderCustomerDiscount, 0.0)) {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.easyPack), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderEasyPack, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.customerInvoiceDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderCustomerInvoiceDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.customerInvoiceNumber), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.renaultInvoiceDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderRenaultInvoiceDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.carSaleAvailibilityDateMADA, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderMADADate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.carSaleAvailibilityDateMADC, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderMADCDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.modelID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderModelId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.versionID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderVersionId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.phase), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderPhase, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.salesmanName), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderSalesmanName, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.agentCode), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(order.body.orderAgentCode, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.attributionVehicleDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(order.body.orderAttributionVehicleDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        }))
                ];
        }));
  return React.createElement(Order_Detail_Correct_Box$DvmAdminFrontendFr.make, {
              content: Belt_Array.keepMap([
                    Belt_Option.mapWithDefault(tooltipHeight, undefined, (function (x) {
                            return Caml_option.some(React.createElement("div", {
                                            style: {
                                              height: x
                                            }
                                          }));
                          })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.orderType,
                              children: Belt_Option.mapWithDefault(order.header.orderOrderType, "-", Order_Detail_Types_Order_Type$DvmAdminFrontendFr.toString) + match$1[0]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.orderDateV2,
                              children: Belt_Option.mapWithDefault(order.body.orderOrderDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[1]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.customerName,
                              children: Belt_Option.getWithDefault(order.body.orderCustomerName, "-") + match$1[2]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.clientFirstName,
                              children: Belt_Option.getWithDefault(order.body.orderCustomerFirstName, "-") + match$1[3]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDate,
                              children: Belt_Option.mapWithDefault(order.body.orderRegistrationDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[4]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationNumber,
                              children: Belt_Option.getWithDefault(order.body.orderRegistrationId, "-") + match$1[5]
                            })),
                    form.input.orderType === /* VE */2 || form.input.orderType === /* AD */13 || form.input.orderType === /* RR */4 || form.input.orderType === /* RC */5 ? Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                label: Messages_Orders_Detail$DvmAdminFrontendFr.dateInputParc,
                                children: Belt_Option.mapWithDefault(order.body.resultCalcPARCStartDate, Belt_Option.mapWithDefault(order.body.resultCalcPARCStartDate, "-", (function (param) {
                                            return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                          })), (function (param) {
                                        return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                      })) + match$1[6]
                              })) : undefined,
                    form.input.orderType === /* VE */2 || form.input.orderType === /* AD */13 || form.input.orderType === /* RR */4 || form.input.orderType === /* RC */5 ? Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                label: Messages_Orders_Detail$DvmAdminFrontendFr.dateOutputParc,
                                children: Belt_Option.mapWithDefault(order.body.resultPARCEndDate, "-", (function (param) {
                                        return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                      })) + match$1[7]
                              })) : undefined,
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.discountTTC,
                              children: Belt_Option.mapWithDefault(order.body.orderCustomerDiscount, "-", (function (x) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                                    })) + match$1[8]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_FinancialCodes$DvmAdminFrontendFr.codeId,
                              children: Belt_Option.getWithDefault(order.body.orderEasyPack, "-") + match$1[9]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceClient,
                              children: Belt_Option.mapWithDefault(order.body.orderCustomerInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[10]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceNumber,
                              children: Belt_Option.getWithDefault(order.body.orderCustomerInvoiceNumber, "-") + match$1[11]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.invoiceDateV2,
                              children: Belt_Option.mapWithDefault(order.body.orderRenaultInvoiceDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[12]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.madaDate,
                              children: Belt_Option.mapWithDefault(order.body.orderMADADate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[13]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Orders_Detail$DvmAdminFrontendFr.madcDate,
                              children: Belt_Option.mapWithDefault(order.body.orderMADCDate, "-", (function (param) {
                                      return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                    })) + match$1[14]
                            })),
                    User_Types_Utils$DvmAdminFrontendFr.whatCountry(match[0].selectedRole) === /* Spain */1 ? Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                label: Messages_Orders_Detail$DvmAdminFrontendFr.attributionDateVin,
                                children: Belt_Option.mapWithDefault(order.body.orderAttributionVehicleDate, "-", (function (param) {
                                        return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                      })) + match$1[20]
                              })) : undefined,
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.model,
                              children: Belt_Option.getWithDefault(order.body.orderModelId, "-") + match$1[15]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.version,
                              children: Belt_Option.getWithDefault(order.body.orderVersionId, "-") + match$1[16]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.phase,
                              children: Belt_Option.getWithDefault(order.body.orderPhase, "-") + match$1[17]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.seller,
                              children: Belt_Option.getWithDefault(order.body.orderSalesmanName, "-") + match$1[18]
                            })),
                    Caml_option.some(React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                              label: Messages_Common$DvmAdminFrontendFr.agent,
                              children: Belt_Option.getWithDefault(order.body.orderAgentCode, "-") + match$1[19]
                            }))
                  ], (function (x) {
                      return x;
                    })),
              color: color,
              title: title
            });
}

var make = Order_Detail_Correct_Order_Content_NonFleet;

export {
  make ,
}
/* react Not a pure module */
